import HttpService from '../../../core/rest/http.service';
export async function loadCategories(servicesGroupId, structureGroupId, vocabularyGroupId) {
    let parameters = {};
    parameters = {
        sluzbyGroupId: servicesGroupId || undefined,
        structureGroupId: structureGroupId || undefined,
        vocabularyGroupId: vocabularyGroupId || undefined,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/sluzby-kategorie";
    return HttpService.get(endpoint, parameters);
}
export async function loadSubCategories(categoryId = null, servicesGroupId, structureGroupId, vocabularyGroupId) {
    let parameters = {};
    parameters = {
        kategorieId: categoryId,
        sluzbyGroupId: servicesGroupId || undefined,
        structureGroupId: structureGroupId || undefined,
        vocabularyGroupId: vocabularyGroupId || undefined,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/sluzby-kategorie";
    return HttpService.get(endpoint, parameters);
}
